import { render, staticRenderFns } from "./myTopic.vue?vue&type=template&id=f8224f34&scoped=true"
import script from "./myTopic.vue?vue&type=script&lang=js"
export * from "./myTopic.vue?vue&type=script&lang=js"
import style0 from "./myTopic.vue?vue&type=style&index=0&id=f8224f34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8224f34",
  null
  
)

export default component.exports